module.exports = __webpack_public_path__ + "img/home-grid-info-i-wuye.9a2a9813.png";